import React from 'react';
import PropTypes from 'prop-types';

const NYG = props => {

  return (
    <svg
      width={40}
      height={40}
      preserveAspectRatio="xMidYMid slice"
      clipRule="evenodd"
      fillRule="evenodd"
      viewBox="0 0 560 400"
      xmlns="http://www.w3.org/2000/svg"
      id="Giants"
    >
      <path
        d="m238.507 100.007c-9.52.196-18.679 3.145-25.595 8.433v-6.736h-61.872l-.014 35.385h14.396c2.964 0 5.361 2.407 5.361 5.363v100.378h42.148v-93.792l.003-.986h.005c.004-5.617 4.762-10.174 10.636-10.174 5.786 0 10.485 4.438 10.612 9.958v76.5c0 2.236.426 4.361 1.159 6.335 2.579 6.937 9.229 11.886 17.055 11.886h39.542v-33.94l-.828-.005h-9.164c-2.956-.001-5.357-2.394-5.357-5.353v-.742l-.008-.224.008-3.813v-25.735l-.008-5.039.008-8.095v-30.584c-.059-.889-.205-2.245-.562-3.88-.613-2.787-1.831-6.385-4.266-9.942-5.082-7.412-11.542-11.452-20.231-13.718-4.302-1.086-8.703-1.567-13.03-1.478v-.003zm45.569 1.7v35.283h10.998c2.956 0 5.349 2.401 5.349 5.361v68.99c.707 11.361 7.455 21.751 16.031 26.621 8.632 6.828 29.571 9.953 40.88 5.963 0 0 5.222-1.644 8.161-3.604v8.754c0 2.089-.161 3.392-.728 5.019-1.436 3.095-4.587 4.72-9.589 4.843l-184.418-.008v41.027h199.887c6.082-.313 11.806-1.001 16.623-2.362 6.582-2.012 21.65-9.071 21.65-31.388 0-.326-.005-8.534-.014-8.865h-.003l-.105-155.63h-43.159v90.597c0 1.093-.019 2.181-.074 3.248-.016.424-.042.838-.076 1.254-.42 3.295-2.416 6.108-5.254 7.739-1.656.948-3.575 1.504-5.634 1.504-5.942 0-10.978-4.537-10.958-10.166l.055-94.176h-59.618z"
        fill="#a71930"
      />
      <path
        d="m238.752 105.944c-8.274.136-16.221 2.644-22.22 7.228l-9.565 7.324v-12.833h-49.979l-.003 23.478h8.441c6.238 0 11.308 5.073 11.308 11.312v94.421h30.248v-87.869s.004-.992.012-.952c.009-8.891 7.443-16.126 16.586-16.126 8.937 0 16.367 7.077 16.567 15.908v76.499c0 1.432.263 2.872.784 4.262 1.779 4.789 6.393 8.005 11.475 8.005h33.586v-22.029h-4.037c-6.235 0-11.309-5.077-11.309-11.312h.003v-.593l-.008-.254.008-3.931v-25.72l-.008-5.066.008-8.082v-30.269c-.042-.267-.422-2.92-.422-2.92-.638-2.872-1.771-5.513-3.372-7.847-4.061-5.927-9.096-9.314-16.777-11.317-3.74-.947-7.568-1.375-11.328-1.315l.001-.001zm132.83 1.716v84.644l-.077 3.549-.1 1.525-.026.169c-.627 5.028-3.699 9.572-8.188 12.164-2.613 1.5-5.584 2.293-8.596 2.293-4.6 0-9.076-1.833-12.274-5.053-2.991-3.003-4.642-6.918-4.642-11.019 0-.018.054-77.82.058-88.269h-47.707v23.376h5.039c6.235 0 11.304 5.076 11.304 11.311v68.728c.58 8.894 5.798 17.609 13.016 21.709v-.003l.393.23.362.274c7.128 5.638 25.882 8.321 35.202 5.022l.19-.055c1.714-.547 5.038-1.805 6.643-2.89l9.264-6.198v19.908c0 2.436-.177 4.465-1.063 6.989l-.089.27-.13.266c-1.694 3.654-5.643 8.064-14.987 8.292h-178.46v29.113c11.177.02 193.334 0 193.725 0 5.592-.293 10.842-.907 15.077-2.093 6.509-1.999 17.437-7.997 17.437-25.704 0 0-.101-147.537-.111-158.548h-31.262l.001-.001z"
        fill="#0b2265"
      />
    </svg>
  );
};

NYG.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

NYG.defaultProps = {
  size: '100'
};

export default NYG;
